import { render, staticRenderFns } from "./PscMonthlySummary.vue?vue&type=template&id=70067f1c&scoped=true&"
import script from "./PscMonthlySummary.vue?vue&type=script&lang=js&"
export * from "./PscMonthlySummary.vue?vue&type=script&lang=js&"
import style0 from "./PscMonthlySummary.vue?vue&type=style&index=0&id=70067f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70067f1c",
  null
  
)

export default component.exports